export interface HistoryState<T> {
  current: T;
  past: T[];
  future: T[];
}

export enum HistoryStateActionType {
  UNDO = "undo",
  REDO = "redo",
  UPDATE = "update",
  RESET = "reset",
}

export interface HistoryStateActionWithPayload<T> {
  type: HistoryStateActionType.UPDATE | HistoryStateActionType.RESET;
  payload: T;
}

export type HistoryStateAction<T> =
  | HistoryStateActionWithPayload<T>
  | { type: Exclude<HistoryStateActionType, HistoryStateActionType.UPDATE | HistoryStateActionType.RESET> };

export type HistorySetStateInput<T> = T | ((prevState: T) => T);

export interface StateWithHistory<T> {
  past: T[];
  future: T[];
  undo: () => void;
  redo: () => void;
  reset: (payload?: T) => void;
}
